// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1h-2";
export var blackBorderOnHover = "_1h-7";
export var cell = "_1h-6";
export var cellContainer = "_1h-3";
export var checked = "_1h-8";
export var disabled = "_1h-5";
export var featuredIconCellContainer = "_1h-9";
export var featuredIconTextContainer = "_1h-b";
export var featuredIconWrapper = "_1h-a";
export var noBorder = "_1h-c";
export var orangeSelectedRow = "_47-3";
export var overflowableText = "_1h-0";
export var overflowableTextContainer = "_1h-1";
export var row = "_1j-0";
export var rowCheckboxCell = "_1h-4";
export var selectableTable = "_47-2";